<template>
<div>

<compFormEdit ref="formbase" class="margin-layout" :formdata="getBase" v-model="formData"  :labelWidth="150"></compFormEdit>
  <vButtonGroup class="text-right">
          <vButton @click="submit" theme="primary">{{$t('global.modal.confirm', { defaultValue: "确定" })}}</vButton>
          <vButton @click="cancel">{{$t('global.common.cancel', { defaultValue: "取消" })}}</vButton>
  </vButtonGroup>
  <vLoading loading size="large" transfer v-if="loading"></vLoading>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
    HttpSaveHoliday,
    HttpGetOne
} from "@/service/holiday";
export default {
  props: ["activeid","type"],
  created() {
    this.getDetail();
      
  },
  data() {
    return {
      loading: false,
      id:  this.activeid,
      formData: {
      },
      required: [
        {
          required: true,
          message: "该信息不能为空,请填写"
        }
      ],
    };
  },
  computed: {
      ...mapGetters('dictionary', ['getCountryList']),
        isAdd() {
			return this.type === 'add'
        },
        isEdit() {
			return this.type === 'edit'
        },
      
        isQuery() {
			return this.type === 'query'
        },
      
     getBase() {
			return [
			{
                label: this.$t('erp.channelbase.country	', { defaultValue: '国家' }),
                key:"countryCode",
                tag: "vSelect",
                query:!this.isAdd,
                span:24,
                options: this.getCountryList,
                props: {
                    filterable: true
                },
			},{
                label: this.$t('fbb.holiday.description', { defaultValue: '节假日描述' }),
                key: "description",
                tag: "vInput",
                query:!this.isAdd,
                span:24,
            },{
                label: this.$t('fbb.holiday.beginAt', { defaultValue: '节假日起始日期' }),
                key: "beginAt",
                tag: "vDatepicker",
                query:this.isQuery,
                span:24,
                props: {
                    format: 'yy-mm-dd',
                    confirm: false,
                },
            },{
                label: this.$t('fbb.holiday.endAt', { defaultValue: '节假日结束日期' }),
                key: "endAt",
                tag: "vDatepicker",
                query:this.isQuery,
                span:24,
                props: {
                    format: 'yy-mm-dd',
                    confirm: false,
                },
            },{
                label: this.$t('fbb.holiday.days', { defaultValue: '假期天数' }),
                key: "totalDays",
                tag: "vInput",
                show:!this.isAdd,
                query:!this.isAdd,
                span:24,
            }    
            ];
        }
        
  },
  methods: {
      getDetail() {
      if (this.isAdd) return;
      this.loading = true;
      if(this.id){
          HttpGetOne({ id: this.id }).then(res => {
					
          this.formData = res.data;
          this.formData.beginAt = res.data.beginAt.substring(0,10);
          this.formData.endAt = res.data.endAt.substring(0,10);
          this.loading = false;
        }).catch(err => {
            this.loading = false;
            this.$VMessage.error(err.message);
        })
      }
    },
    async submit(){
        const valid = await this.$refs.formbase.validate();
        if (!valid) return;
        
        this.loading = true;
        HttpSaveHoliday({
            ...this.formData
        })
          .then(res => {
            this.loading = false;
            this.$VMessage.success(this.$t('fbb.logistics.cost_add_success', { defaultValue: '添加成功' }));
            this.success();
          }, err => {
            this.loading = false;
                this.$VMessage.error(err.message)
            });
    },
   
    success() {
      this.$emit("on-close");
      this.$emit("on-update");
      this.$emit("refreshPage");
    },
    cancel() {
      this.$emit("on-close");
    }
  }
};
</script>